import React from 'react'

const Wave = () => (
  <svg width="100%" height="300" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="white">
      <animate repeatCount="indefinite" fill="freeze" attributeName="d" dur="20s" values="M2561 107.093L1 1V461H2561V107.093Z;
            M2561 166.093L1 1V461H2561V166.093Z;
            M2561 175.093L1 1V461H2561V175.093Z;
            M2561 200.093L1 1V461H2561V200.093Z" />
    </path>
  </svg>
)

export default Wave